import { z } from 'zod';

export const MAX_APPEND_IGNORE_PATTERNS = 50;
export const MAX_IGNORE_PATTERN_LENGTH = 256;

export const AppendIgnorePatternsPayloadSchema = z.object({
  patterns: z
    .array(z.string().trim().min(1).max(MAX_IGNORE_PATTERN_LENGTH))
    .min(1)
    .max(MAX_APPEND_IGNORE_PATTERNS),
});

export const AppendIgnorePatternsResponseSchema = z.object({
  installationId: z.number(),
  totalRepositories: z.number(),
  /** Repositories that actually changed; 0 means every pattern already existed everywhere. */
  updatedRepositoryCount: z.number(),
});

export type AppendIgnorePatternsPayload = z.infer<typeof AppendIgnorePatternsPayloadSchema>;
export type AppendIgnorePatternsResponse = z.infer<typeof AppendIgnorePatternsResponseSchema>;
